import { useEffect } from 'react';
import fp from 'lodash/fp';

import { useAction, useSelector } from 'Modules/core/redux';

import { LANDING_DOMAIN_PATH } from '../constants';
import { ItemsState, UseGetItems, UseGetItemsProps } from './types';


export const useGetItems = <TItem, PType = void>({
    path,
    loadAction,
    actionPayload,
}: UseGetItemsProps<PType>): UseGetItems<TItem> => {
    const { data, isLoading, error } = useSelector<ItemsState<TItem>>(
        state => fp.getOr({}, `${LANDING_DOMAIN_PATH}.${path}`, state),
        [path],
    );
    const load = useAction(() => loadAction(actionPayload), [actionPayload, loadAction]);
    useEffect(() => {
        if (!data && !isLoading && !error)
            load();
    }, [data, isLoading, load, error]);

    return { data, error, isLoading, load };
};
